import Reveal from "@/components/Reveal";
import JotFormEmbed from "@/components/JotFormEmbed";
import { CalendarCheck } from "lucide-react";

export default function ContactSection() {
  return (
    <section id="contact" className="py-20 sm:py-28" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="bg-[#222222] rounded-[2rem] overflow-hidden grid lg:grid-cols-2">
          <div className="p-8 sm:p-12 lg:p-16 text-white flex flex-col justify-center">
            <Reveal>
              <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FFD3C6]">Partnership Offer</p>
              <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
                Ready to Put Your Property to Work?
              </h2>
              <p className="mt-5 text-base sm:text-lg leading-relaxed text-white/70 max-w-lg">
                We'll pay qualifying landlords $500 to partner with us, manage the short-term rental
                operations, and share the monthly profits 80/20. Let's see what your property could
                potentially earn.
              </p>
              <ul className="mt-8 space-y-3 text-sm sm:text-[15px] font-semibold text-white/85">
                <li className="flex items-center gap-3">
                  <CalendarCheck className="w-5 h-5 text-[#FF5A5F]" />
                  $500 partnership incentive paid to qualifying landlords
                </li>
                <li className="flex items-center gap-3">
                  <CalendarCheck className="w-5 h-5 text-[#FF5A5F]" />
                  You keep 80% of monthly rental profits
                </li>
                <li className="flex items-center gap-3">
                  <CalendarCheck className="w-5 h-5 text-[#FF5A5F]" />
                  No lease required — you keep ownership of your property
                </li>
              </ul>
            </Reveal>
          </div>

          <div className="bg-white p-6 sm:p-10">
            <Reveal>
              <h3 className="text-2xl font-bold text-[#222]">Apply for Our $500 Partnership Offer</h3>
              <p className="mt-2 text-sm text-[#717171]">
                Complete the short intake form below and we'll reach out to evaluate your property's potential.
              </p>
              <div className="mt-6" data-testid="contact-form">
                <JotFormEmbed />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
